var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.href)?_c('a',_vm._b({attrs:{"href":_vm.href,"target":"_blank"}},'a',_vm.$attrs,false),[_vm._t("default")],2):_c('router-link',_vm._b({attrs:{"to":_setup.routerLinkTo}},'router-link',_vm.$attrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }